import React from 'react';
import { FormattedMessage, useIntl } from '../../util/reactIntl';

import { LayoutComposer, Page, H3, H2, ReviewRating } from '../../components';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';
import css from './TestimonialsPage.module.css';

const TestimonialsPage = () => {
  const layoutAreas = `
    topbar
    main
    footer
  `;

  const intl = useIntl();

  return (
    <Page
      className={css.root}
      title={intl.formatMessage({ id: "TestimonialsPage.pageTitle" })}
      scrollingDisabled={false}
    >
      <LayoutComposer areas={layoutAreas} className={css.layout}>
        {({ Topbar, Main, Footer }) => (
          <>
            <Topbar as="header" className={css.topbar}>
              <TopbarContainer />
            </Topbar>
            <Main as="main" className={css.main}>
              <div className={css.content}>
                <H3 className={css.heading}>
                  <FormattedMessage id="TestimonialsPage.heading" />
                </H3>
                <H2 className={css.mainTitle}>
                  <FormattedMessage id="TestimonialsPage.mainTitle" />
                </H2>

                <section className={css.section}>
                  <div className={css.card}>
                    <ReviewRating
                      rating={5}
                      className={css.rating}
                    />
                    <p>
                      Firstly I will start by saying what a great idea the Web page ReBorn Ireland is especially in todays times things are so expensive and people are struggling. Dee is such a lovely helpful friendly person. I placed an ad on the page and I.T. is not my strong point but Dee took me step by step through and she quickly fixed my problem. The price for placing my buggy was so reasonable and within a few hours of my ad being placed I had interest and Im happy to say I sold the buggy. I would highly  highly recommend #ReBorn Ireland  I can not wait to have a look to see what I can buy myself. Five stars ⭐ go on and have a look it is definitely worth a follow 👍
                    </p>
                    <strong>
                      Denise
                    </strong>
                    <br />
                    <span>
                      Limerick
                    </span>
                  </div>
                  <div className={css.card}>
                    <ReviewRating
                      rating={5}
                      className={css.rating}
                    />
                    <p>
                      Hi
                      Just to let you know, I have sold the snuza baby monitor.
                      Thanks very much. Your website is a marvellous idea.
                      I have tried several ways previously to sell on my baby items and have found them all so unreliable. This website is exactly what us mammies needed. It’s a fantastic idea to help other families out.
                      Best wishes with it
                      Aileen
                    </p>
                    <strong>
                      Aileen
                    </strong>
                    <br />
                    <span>
                      Cork
                    </span>
                  </div>
                  <div className={css.card}>
                    <ReviewRating
                      rating={5}
                      className={css.rating}
                    />
                    <p>
                      Just wanted to give this fabulous company a mention. I put an item up on facebook marketplace a couple of weeks ago and had very little interest.

                      On the day I put it on @reborn ireland it was sold.

                      Such a brilliant concept
                    </p>
                    <strong>
                      Brana
                    </strong>
                    <br />
                    <span>

                    </span>
                  </div>
                </section>

              </div>
            </Main>
            <Footer>
              <FooterContainer />
            </Footer>
          </>
        )}
      </LayoutComposer>
    </Page>
  );
};

export default TestimonialsPage;
